import { FileParams } from './../../../../../models/filesParams';
import { Component, EventEmitter, OnInit, Output, ViewChild, } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ConfiguracionAvanzadaService } from 'src/app/dashboard/services/configuracion-avanzada.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Parametros } from 'src/app/dashboard/models/parametros';
import { environment } from 'src/environments/environment.prod';
import { FormDataService } from 'src/app/data/formData.service';
import { Textos } from 'src/app/shared/models/formData.model';
import { Textos2 } from 'src/app/dashboard/models/textos2';
import { Clausulas } from 'src/app/shared/models/formData.model';
import { Clausulas2 } from 'src/app/dashboard/models/clausulas2';
import { Idiomas } from 'src/app/dashboard/models/idiomas';
import { MatSelect } from '@angular/material/select';
import { Response } from 'src/app/shared/models/response.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { forkJoin } from 'rxjs';
import { fileURLToPath } from 'url';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileUtilsService } from 'src/app/shared/services/file-utils.service';

interface ParamData {
  value: string;
  doc: any;
  ruta?: any; // opcional
}

@Component({
  selector: 'app-configuracion-avanzada',
  templateUrl: './configuracion-avanzada.component.html',
  styleUrls: ['./configuracion-avanzada.component.css'],
})
export class ConfiguracionAvanzadaComponent implements OnInit {
  basePath = environment.baseUrl; // O cualquier variable que tengas en environment.ts
  @Output() cambioSSO: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatSelect) matSelect: MatSelect;
  PHP_API_SERVER = environment.baseUrl;

  validatingForm: FormGroup;
  validatingFormDocs: FormGroup;
  validatingFormImages: FormGroup;
  validatingFormMail: FormGroup;
  validatingFormColores: FormGroup;
  validatingFormTextos: FormGroup;
  validatingFormClausulas: FormGroup;
  validatingFormSSO: FormGroup;
  validatingFormMultisociedad: FormGroup;
  validatingFormIdiomas: FormGroup;
  emailF: string = '';
  emailSupportF: string = '';
  dominioF: string = '';
  avisoF: string = '';
  //anonimoF: boolean = false;
  anonimoF: string = '';
  clausulasF: string = '';
  conflictoF: string = '';
  diasinvesF: string = '';
  diasdecisorF: string = '';
  diascomplianceF: string = '';
  diasrecepcionF: string = '';
  diasverdenunciaF: string = '';

  logoF: string = '';
  inicio1F: string = '';
  inicio2F: string = '';
  inicio3F: string = '';
  fondo_denuncianteF: string = '';
  wizard1F: string = '';
  wizard2F: string = '';
  wizard3F: string = '';
  wizard4F: string = '';
  wizard5F: string = '';
  wizard6F: string = '';
  wizard7F: string = '';
  logindenuncianteF: string = '';
  cabeceramailF: string = '';

  nremitenteF: string = '';
  remitenteF: string = '';
  srv_mailF: string = '';
  puertoF: string = '';
  usr_mailF: string = '';
  pass_mailF: string = '';
  auth_mailF: boolean = false;
  sslF: boolean = false;

  colorbgseccion1F: string = '';
  colorbgseccion2F: string = '';
  colorbgseccion3F: string = '';
  colorprincipalF: string = '';
  colorsecundarioF: string = '';
  colortxtbtnF: string = '';
  colortxtseccion1F: string = '';
  colortxtseccion2F: string = '';
  colortxtseccion3F: string = '';
  colortxttituloF: string = '';
  colormenulateralF: string = '';
  colortxtcabecerasF: string = '';
  colortxtbotonesF: string = '';
  colortxtFondoF: string = '';

  parametros: Parametros;
  ssoParametros: Parametros;

  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;

  color: string;

  selectedTipo: string = '';
  selectedClausulas: string = '';
  selectedConflicto: string = '';
  selectedConflictoCompliance: string = '';
  selectedTriaje: string = '';
  selectedCenters: string = ''; //checkbox centers
  selectedinputAutocomplete: string = ''; //checkbox inputAutocomplete

  textos: Textos;
  customTextos: Textos;
  textos2: Textos2[];
  textoF: string = '';
  textoCustomF: string = '';
  selectedIdTexto: string;

  filteredTextos: Textos2[];
  filteredCustomTextos: Textos2[];
  allTextos: Textos2[];
  allCustomTextos: Textos2[];

  clausulas: Clausulas;
  clausulas2: Clausulas2[] = [];
  clausulaF: string = '';
  selectedIdClausula: string;

  rutaTerminosF: string = '';
  docTerminosF: string = '';

  rutaPoliticaF: string = '';
  docPoliticaF: string = '';

  rutaPoliticaClienteF: string = '';
  docPoliticaClienteF: string = '';

  //fichero: boolean;
  selectedTerminos: string;

  //fichero politica privacidad: boolean;
  selectedPolitica: string;

  //fichero politica privacidad cliente: boolean;
  selectedPoliticaCliente: string;

  //fichero: boolean;
  selectedBoton1: string;
  docBoton1F: string = '';

  selectedBoton2: string;
  docBoton2F: string = '';

  selectedBoton3: string;
  docBoton3F: string = '';

  selectedRutaDrive: string;
  rutaDriveF: string = '';

  // Declare variable to store the local storage value
  selectedPopUp: string;
  selectedSupportForm: string;
  selectedComplianceNotification: string;
  selectedDocumentPreview: string;
  dias_visible: string = '';

  saml_enabledF: boolean = false;
  saml_idp_entity_idF: string = '';
  saml_idp_sso_urlF: string = '';
  saml_idp_sloF: string = '';
  saml_idp_certF: string = '';
  saml_idp_cert2F: string = '';
  saml_mapping_cnF: string = '';
  saml_mapping_snF: string = '';
  saml_mapping_emailF: string = '';
  saml_mapping_phoneF: string = '';
  saml_mapping_national_idF: string = '';
  saml_jitF: boolean = false;
  saml_sloF: boolean = false;
  saml_force_loginF: boolean = false;
  saml_debugF: boolean = false;
  saml_sp_entity_idF: string = '';
  saml_sp_pkF: string = '';
  saml_sp_certF: string = '';
  selectedsaml_sp_nameid_format: string = '';

  multiF: boolean = false;
  tieneSSOF: boolean = false;
  archivardenunciaF: boolean = false;
  idPersonalizableEnabledF: boolean = false;
  gAnalyticsEnabledF: boolean = false;

  hasSSO: boolean = false;
  showAdvOpts: boolean = false;

  idiomas: Idiomas[];
  enabledLanguages: Idiomas[];
  IsHiddenForm: boolean = false;
  id_idioma: string;
  n_idioma: string;
  bandera: string;
  comentario: string;
  Habilitado: string;
  Habilitadochk: boolean = false;

  ValorMostrar: string;
  emailErrors: string = ''; //Email Consultas Error
  emailSupportErrors: string = '';

  currentDocTerminos: string;
  currentDocBoton1: string;
  currentDocBoton2: string;
  currentDocBoton3: string;
  currentDocPolitica: string;
  currentDocPoliticaCliente: string;

  pdfPreviews: { [key: string]: Boolean | null } = {};

  url: SafeResourceUrl | null = null;
  showFile = false;
  mimeType: string | null = null;


  //event handler for the select element's change event
  selectChangeHandler(event: any) {
    //update the ui
    this.selectedTipo = event.target.value;
  }

  //event handler for the select element's change event
  selectChangeHandler2(event2: any) {
    //update the ui
    this.selectedClausulas = event2.target.value;
  }

  //event handler for the select element's change event
  selectChangeHandler3(event3: any) {
    //update the ui
    this.selectedConflicto = event3.target.value;
  }

  //event handler for the select element's change event
  selectChangeHandler8(event8: any) {
    //update the ui
    this.selectedTriaje = event8.target.value;
  }

  //Event check centers
  selectChangeHandlerCenters(eventCenter: any) {
    //update the ui
    this.selectedCenters = eventCenter.target.value;
  }

  //Event check de Input Autocomplete
  selectChangeHandlerInputAutocomplete(eventInputAutocomplete: any) {
    //update the ui
    this.selectedinputAutocomplete = eventInputAutocomplete.target.value;
  }

  //Documento Términos y Condiciones
  selectChangeHandlerTerminos(event4: any) {
    this.selectedTerminos = event4.target.value;
  }

  selectChangeHandlerBtn1(event5: any) {
    this.selectedBoton1 = event5.target.value;
  }

  selectChangeHandlerBtn2(event6: any) {
    this.selectedBoton2 = event6.target.value;
  }

  selectChangeHandlerBtn3(event7: any) {
    this.selectedBoton3 = event7.target.value;
  }

  selectChangeHandler13(event13: any) {
    this.selectedRutaDrive = event13.target.value;
  }

  //event handler for the select element's change event
  selectChangeHandler9(event9: any) {
    //update the ui
    this.selectedsaml_sp_nameid_format = event9.target.value;
  }
  selectChangeHandler10(event10: any) {
    this.selectedPopUp = event10.target.value;
    //console.log("Variable popUp: ", this.selectedPopUp);

  }

  /**
   * Event handler for the change event of a select element.
   * Updates the status of selectedPolitica depending if user selected URL or Document.
   *
   * @param {Event} event11 - The event triggered by the select element when its value changes.
   */
  selectChangeHandlerPoliticaBec(event11: Event): void {
    this.selectedPolitica = (event11.target as HTMLSelectElement).value;
  }

  /**
   * Event handler for the change event of a select element.
   * Updates the status of selectedPoliticaCliente depending if user selected URL or Document.
   *
   * @param {Event} event12 - The event triggered by the select element when its value changes.
   */
  selectChangeHandlerPoliticaCli(event12: Event): void {
    this.selectedPoliticaCliente = (event12.target as HTMLSelectElement).value;
  }

  selectChangeHandler14(event14: any) {
    this.selectedSupportForm = event14.target.value;
  }

  /**
   * @description Event handler for the select element's change event.
   */
  selectChangeHandler16(event16: any) {
    this.selectedComplianceNotification = event16.target.value;
  }

  selectChangeHandler15(event15: any) {
    this.selectedConflictoCompliance = event15.target.value;
  }

  selectChangeHandlerDocPreview(event16: any) {
    this.selectedDocumentPreview = event16.target.value;
  }

  constructor(
    private configuracionAvanzadaService: ConfiguracionAvanzadaService,
    private apiService: ApiService,
    private formDataService: FormDataService,
    private auth: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private fileUtilsService: FileUtilsService
  ) { }

  ngOnInit() {
    let idioma = this.auth.getLanguage();
    if (idioma == '' || idioma == null) {
      idioma = 'es';
    }

    this.loadEnabledLanguages()

    this.showAdvOpts = this.auth.getShowAdvOpts();

    this.configuracionAvanzadaService
      .searchTodosIdiomas()
      .subscribe((idiomas: Idiomas[]) => {
        this.idiomas = idiomas;
      },
        err => {
          this.toastr.error(this.translate.instant('texto_813'), this.translate.instant('texto_153'));
        });

    this.configuracionAvanzadaService
      .searchAdvancedParam(this.auth.getSociedad())
      .subscribe({
        next: (response) => {
          if (response.success && response.data && response.code === 200) {
            this.parametros = response.data;

            this.selectedTipo = this.parametros[0]?.valor ?? '';
            this.auth_mailF = this.parametros[1]?.valor === '1';
            this.cabeceramailF = this.parametros[2]?.valor ?? '';
            this.selectedClausulas = this.parametros[3]?.valor ?? '';
            this.colorbgseccion1F = this.parametros[4]?.valor ?? '';
            this.colorbgseccion2F = this.parametros[5]?.valor ?? '';
            this.colorbgseccion3F = this.parametros[6]?.valor ?? '';
            this.colorprincipalF = this.parametros[7]?.valor ?? '';
            this.colorsecundarioF = this.parametros[8]?.valor ?? '';
            this.colortxtbtnF = this.parametros[9]?.valor ?? '';
            this.colortxtseccion1F = this.parametros[10]?.valor ?? '';
            this.colortxtseccion2F = this.parametros[11]?.valor ?? '';
            this.colortxtseccion3F = this.parametros[12]?.valor ?? '';
            this.colortxttituloF = this.parametros[13]?.valor ?? '';
            this.selectedConflicto = this.parametros[14]?.valor ?? '';
            this.remitenteF = this.parametros[15]?.valor ?? '';
            this.diascomplianceF = this.parametros[17]?.valor ?? '';
            this.diasdecisorF = this.parametros[18]?.valor ?? '';
            this.diasinvesF = this.parametros[19]?.valor ?? '';
            this.dominioF = this.parametros[20]?.valor ?? '';
            this.fondo_denuncianteF = this.parametros[21]?.valor ?? '';
            this.inicio1F = this.parametros[22]?.valor ?? '';
            this.inicio2F = this.parametros[23]?.valor ?? '';
            this.inicio3F = this.parametros[24]?.valor ?? '';
            this.logindenuncianteF = this.parametros[25]?.valor ?? '';
            this.logoF = this.parametros[26]?.valor ?? '';
            this.emailF = this.parametros[27]?.valor ?? '';
            this.nremitenteF = this.parametros[28]?.valor ?? '';
            this.pass_mailF = this.parametros[29]?.valor ?? '';
            this.avisoF = this.parametros[30]?.valor ?? '';
            this.puertoF = this.parametros[31]?.valor ?? '';
            this.srv_mailF = this.parametros[32]?.valor ?? '';
            this.sslF = this.parametros[33]?.valor === '1';
            this.usr_mailF = this.parametros[34]?.valor ?? '';
            this.wizard1F = this.parametros[35]?.valor ?? '';
            this.wizard2F = this.parametros[36]?.valor ?? '';
            this.wizard3F = this.parametros[37]?.valor ?? '';
            this.wizard4F = this.parametros[38]?.valor ?? '';
            this.wizard5F = this.parametros[39]?.valor ?? '';
            this.wizard6F = this.parametros[40]?.valor ?? '';
            this.wizard7F = this.parametros[41]?.valor ?? '';
            this.selectedTerminos = this.parametros[42]?.valor ?? '';
            this.docTerminosF = this.parametros[43]?.valor ?? '';
            this.rutaTerminosF = this.parametros[44]?.valor ?? '';
            this.diasverdenunciaF = this.parametros[45]?.valor ?? '';
            this.colormenulateralF = this.parametros[46]?.valor ?? '';
            this.colortxtcabecerasF = this.parametros[47]?.valor ?? '';
            this.colortxtbotonesF = this.parametros[48]?.valor ?? '';
            this.docBoton1F = this.parametros[50]?.valor ?? '';
            this.selectedBoton1 = this.parametros[51]?.valor ?? '';
            this.docBoton2F = this.parametros[52]?.valor ?? '';
            this.selectedBoton2 = this.parametros[53]?.valor ?? '';
            this.docBoton3F = this.parametros[54]?.valor ?? '';
            this.selectedBoton3 = this.parametros[55]?.valor ?? '';
            this.selectedTriaje = this.parametros[56]?.valor ?? '';
            this.multiF = this.parametros[57]?.valor === '1';
            this.tieneSSOF = this.parametros[58]?.valor === '1';
            this.dias_visible = this.parametros[59]?.valor ?? '';
            this.archivardenunciaF = this.parametros[60]?.valor === '1';
            this.selectedCenters = this.parametros[61]?.valor ?? '';
            this.selectedinputAutocomplete = this.parametros[62]?.valor ?? '';
            this.selectedPopUp = this.parametros[63]?.valor ?? '';
            this.selectedPolitica = this.parametros[64]?.valor ?? '';
            this.docPoliticaF = this.parametros[65]?.valor ?? '';
            this.rutaPoliticaF = this.parametros[66]?.valor ?? '';
            this.colortxtFondoF = this.parametros[67]?.valor ?? '';
            this.idPersonalizableEnabledF = this.parametros[68]?.valor === '1';
            this.selectedPoliticaCliente = this.parametros[74]?.valor ?? '';
            this.docPoliticaClienteF = this.parametros[75]?.valor ?? '';
            this.rutaPoliticaClienteF = this.parametros[76]?.valor ?? '';
            this.gAnalyticsEnabledF = this.parametros[77]?.valor === '1';
            this.rutaDriveF = this.parametros[79]?.valor ?? '';
            this.selectedRutaDrive = this.parametros[80]?.valor ?? '';
            this.diasrecepcionF = this.parametros[81]?.valor ?? '';
            this.emailSupportF = this.parametros[82]?.valor ?? '';
            this.selectedSupportForm = this.parametros[84]?.valor ?? '';
            this.selectedConflictoCompliance = this.parametros[85]?.valor ?? '';
            this.selectedDocumentPreview = this.parametros[86]?.valor ?? '';
            this.selectedComplianceNotification = this.parametros[87]?.valor ?? '';
            this.hasSSO = this.tieneSSOF;
            this.saml_enabledF = this.tieneSSOF;

            this.updateDocNgModels(idioma);
          } else if (response.code === 404 && !response.success) {
            this.toastr.error(this.translate.instant('texto_899'));
          }
        },
        error: (err) => {
          this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_813'));
        }
      });


    this.configuracionAvanzadaService
      .searchSSOdParam(this.auth.getSociedad())
      .subscribe({
        next: (ssoParametros: Response) => {
          this.ssoParametros = ssoParametros.data;
          if (this.ssoParametros[0].valor == '1') {
            this.saml_enabledF = true;
          } else {
            this.saml_enabledF = false;
          }
          if (this.tieneSSOF) {
            this.saml_enabledF = true;
          }
          this.saml_idp_entity_idF = this.ssoParametros[1].valor;
          this.saml_idp_sso_urlF = this.ssoParametros[2].valor;
          this.saml_idp_sloF = this.ssoParametros[3].valor;
          this.saml_idp_certF = this.ssoParametros[4].valor;
          this.saml_idp_cert2F = this.ssoParametros[5].valor;
          this.saml_mapping_cnF = this.ssoParametros[6].valor;
          this.saml_mapping_snF = this.ssoParametros[7].valor;
          this.saml_mapping_emailF = this.ssoParametros[8].valor;
          this.saml_mapping_phoneF = this.ssoParametros[9].valor;
          this.saml_mapping_national_idF = this.ssoParametros[10].valor;
          if (this.ssoParametros[11].valor == '1') {
            this.saml_jitF = true;
          } else {
            this.saml_jitF = false;
          }
          if (this.ssoParametros[12].valor == '1') {
            this.saml_sloF = true;
          } else {
            this.saml_sloF = false;
          }
          if (this.ssoParametros[13].valor == '1') {
            this.saml_force_loginF = true;
          } else {
            this.saml_force_loginF = false;
          }
          if (this.ssoParametros[14].valor == '1') {
            this.saml_debugF = true;
          } else {
            this.saml_debugF = false;
          }
          this.saml_sp_entity_idF = this.ssoParametros[15].valor;
          this.saml_sp_pkF = this.ssoParametros[16].valor;
          this.saml_sp_certF = this.ssoParametros[17].valor;
          this.selectedsaml_sp_nameid_format = this.ssoParametros[18].valor;
        }, error: (err) => {
          this.ssoParametros = null;
        }
      })

    this.textos = this.formDataService.getTexto();
    if (this.textos.id_texto != '') {
      this.configuracionAvanzadaService
        .searchTextos(this.textos.id_texto, idioma, this.auth.getSociedad())
        .subscribe({
          next: (response: Response<Textos2[]>) => {
            this.textos2 = response.data;
            this.textoF = response.data[0].texto;
          },
          error: (err) => {
            if (err.error.code !== 400) {
              this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_813'));
            }
            this.textoF = '';
            this.textos2 = [];
          }
        });
    }


    this.customTextos = this.formDataService.getTexto();
    if (this.customTextos.id_texto != '') {
      this.configuracionAvanzadaService
        .searchTextos(this.customTextos.id_texto, idioma, this.auth.getSociedad())
        .subscribe({
          next: (response: Response<Textos2[]>) => {
            this.textos2 = response.data;
            this.textoF = response.data[0].texto;
          },
          error: (err) => {
            if (err.error.code !== 400) {
              this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_813'));
            }
            this.textoF = '';
            this.textos2 = [];
          }
        });
    }

    this.clausulas = this.formDataService.getClausula();
    if (this.clausulas.id_clausula != '') {
      this.configuracionAvanzadaService
        .searchClausulas(this.clausulas.id_clausula, this.auth.getSociedad())
        .subscribe((response: Response<Clausulas>) => {
          if (response.success && response.data && response.code === 200) {
            this.clausulas = response.data;
            this.clausulaF = this.clausulas[0].clausula;
          }
        }, error => {
          if (error.error.code === 500 && !error.error.success) {
            this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_813'));
            this.clausulaF = '';
          }
        });

    }



    this.validatingForm = new FormGroup({
      email: new FormControl('', this.validateEmails),
      emailSupport: new FormControl('', this.validateEmails),
      dominio: new FormControl('', []),
      aviso: new FormControl('', []),
      anonimo: new FormControl('', []),
      calusulas: new FormControl('', []),
      triaje: new FormControl('', []),
      centros: new FormControl('', []),
      autocomplete: new FormControl('', []),
      conflicto: new FormControl('', []),
      conflictoCompliance: new FormControl('', []),
      diasinves: new FormControl('', []),
      diasdecisor: new FormControl('', []),
      diascompliance: new FormControl('', []),
      diasrecepcion: new FormControl('', []),
      popUp: new FormControl('', []),
      supportForm: new FormControl('', []),
      diasverdenuncia: new FormControl('', []),
      drive: new FormControl('', []),
      rutaDrive: new FormControl('', []),
      documentPreview: new FormControl('', []),
      complianceNotification: new FormControl('', []),
    });

    this.validatingFormDocs = new FormGroup({
      idiomaDocs: new FormControl('', [Validators.required]),
      terminos: new FormControl('', []),
      rutaTerminos: new FormControl('', []),
      docTerminos: new FormControl('', []),
      politica: new FormControl('', []),
      rutaPolitica: new FormControl('', []),
      docPolitica: new FormControl('', []),
      politicaCliente: new FormControl('', []),
      rutaPoliticaCliente: new FormControl('', []),
      docPoliticaCliente: new FormControl('', []),
      boton1: new FormControl('', []),
      docBoton1: new FormControl('', []),
      boton2: new FormControl('', []),
      docBoton2: new FormControl('', []),
      boton3: new FormControl('', []),
      docBoton3: new FormControl('', []),
      fichTerminos: new FormControl('', []),
      fichBoton1: new FormControl('', []),
      fichBoton2: new FormControl('', []),
      fichBoton3: new FormControl('', []),
      fichPoliticaBec: new FormControl('', []),
      fichPoliticaCli: new FormControl('', []),
      fileSourceTerminos: new FormControl('', []),
      fileSourcePoliticaBec: new FormControl('', []),
      fileSourcePoliticaCli: new FormControl('', []),
      fileSourceBoton1: new FormControl('', []),
      fileSourceBoton2: new FormControl('', []),
      fileSourceBoton3: new FormControl('', []),
    });

    this.validatingFormColores = new FormGroup({
      colorprincipal: new FormControl('', []),
      colorsecundario: new FormControl('', []),
      colorbgseccion1: new FormControl('', []),
      colorbgseccion2: new FormControl('', []),
      colorbgseccion3: new FormControl('', []),
      colortxtbtn: new FormControl('', []),
      colortxtseccion1: new FormControl('', []),
      colortxtseccion2: new FormControl('', []),
      colortxtseccion3: new FormControl('', []),
      colortxttitulo: new FormControl('', []),
      colormenulateral: new FormControl('', []),
      colortxtcabeceras: new FormControl('', []),
      colortxtbotones: new FormControl('', []),
      colortxtFondo: new FormControl(''),
    });

    this.validatingFormImages = new FormGroup({
      file: new FormControl('', []),
      fileSource: new FormControl('', []),
      fich: new FormControl('', []),
      logo: new FormControl('', []),
      inicio1: new FormControl('', []),
      inicio2: new FormControl('', []),
      inicio3: new FormControl('', []),
      fondo_denunciante: new FormControl('', []),
      wizard1: new FormControl('', []),
      wizard2: new FormControl('', []),
      wizard3: new FormControl('', []),
      wizard4: new FormControl('', []),
      wizard5: new FormControl('', []),
      wizard6: new FormControl('', []),
      wizard7: new FormControl('', []),
      logindenunciante: new FormControl('', []),
      cabeceramail: new FormControl('', []),
    });

    this.validatingFormMail = new FormGroup({
      nremitente: new FormControl('', []),
      remitente: new FormControl('', []),
      srv_mail: new FormControl('', []),
      puerto: new FormControl('', []),
      usr_mail: new FormControl('', []),
      pass_mail: new FormControl('', []),
      auth_mail: new FormControl('', []),
      ssl: new FormControl('', []),
    });

    this.validatingFormMultisociedad = new FormGroup({
      multi: new FormControl('', []),
      tieneSSO: new FormControl('', []),
      archivardenuncia: new FormControl('', []),
      idPersonalizableEnabled: new FormControl('', []),
      gAnalyticsEnabled: new FormControl('', []),

    });

    this.validatingFormIdiomas = new FormGroup({
      frmnidioma: new FormControl(''),
      frmididioma: new FormControl(''),
      frmcomentario: new FormControl(''),
      chkhabilitado: new FormControl('', []),
      icono_idioma: new FormControl('', []),
      fileSourceIdioma: new FormControl('', []),
    });

    this.validatingFormTextos = new FormGroup({
      id_texto: new FormControl('', []),
      texto_value: new FormControl('', []),
      id_custom_texto: new FormControl('', []),
      custom_texto_value: new FormControl('', []),
    });

    this.validatingFormClausulas = new FormGroup({
      id_clausula: new FormControl('', []),
      clausula_value: new FormControl('', []),
    });

    this.validatingFormSSO = new FormGroup({
      saml_enabled: new FormControl('', []),
      saml_idp_entity_id: new FormControl('', []),
      saml_idp_sso_url: new FormControl('', []),
      saml_idp_slo: new FormControl('', []),
      saml_idp_cert: new FormControl('', []),
      saml_idp_cert2: new FormControl('', []),
      saml_mapping_cn: new FormControl('', []),
      saml_mapping_sn: new FormControl('', []),
      saml_mapping_email: new FormControl('', []),
      saml_mapping_phone: new FormControl('', []),
      saml_mapping_national_id: new FormControl('', []),
      saml_jit: new FormControl('', []),
      saml_slo: new FormControl('', []),
      saml_force_login: new FormControl('', []),
      saml_debug: new FormControl('', []),
      saml_sp_entity_id: new FormControl('', []),
      saml_sp_pk: new FormControl('', []),
      saml_sp_cert: new FormControl('', []),
      saml_sp_nameid_format: new FormControl('', []),
    });

    this.configuracionAvanzadaService
      .searchTextos2(this.textos.id_texto, false, this.auth.getLanguage(), this.auth.getSociedad())
      .subscribe((textos2: Textos2[]) => {
        this.textos2 = textos2;
        this.allTextos = textos2; // Inicializar allTextos con todos los textos
        this.filteredTextos = this.allTextos; // Inicializar filteredTextos con todos los textos
      },
        err => {
          this.toastr.error(this.translate.instant('teato_813'), this.translate.instant('texto_813'));
        });

    // Search customizable texts
    this.configuracionAvanzadaService
      .searchCustomTextos(this.textos.id_texto, false, this.auth.getLanguage(), this.auth.getSociedad())
      .subscribe((textos2: Textos2[]) => {
        this.textos2 = textos2;
        this.allCustomTextos = textos2;
        this.filteredCustomTextos = this.allCustomTextos;
      },
        err => {
          this.toastr.error(this.translate.instant('texto_813'), this.translate.instant('texto_813'));
        });

  }



  /**
   * Updates the document model values for the currently selected language.
   *
   * This method parses the stored JSON structures that contain document paths
   * (grouped by language) and retrieves the path corresponding to the provided `lang`.
   *
   * It updates the component’s current document path properties used for display or editing.
   *
   * @param lang - The language code to load document paths for (e.g., 'en', 'es', 'pt').
   */
  updateDocNgModels(lang: string) {
    /**
     * Helper function to safely parse a JSON string or return an empty object if invalid.
     */
    const parseOrEmpty = (val: string) => {
      try {
        return val ? JSON.parse(val) : {};
      } catch {
        return {};
      }
    };

    // Assigns the document path for each file type based on the selected language
    this.currentDocTerminos = parseOrEmpty(this.docTerminosF)[lang] || '';
    this.currentDocBoton1 = parseOrEmpty(this.docBoton1F)[lang] || '';
    this.currentDocBoton2 = parseOrEmpty(this.docBoton2F)[lang] || '';
    this.currentDocBoton3 = parseOrEmpty(this.docBoton3F)[lang] || '';
    this.currentDocPolitica = parseOrEmpty(this.docPoliticaF)[lang] || '';
    this.currentDocPoliticaCliente = parseOrEmpty(this.docPoliticaClienteF)[lang] || '';
  }

  loadEnabledLanguages() {
    this.apiService.searchIdiomas()
      .subscribe({
        next: (res) => {
          if (res.code === 200 && res.success && res.data) {
            this.enabledLanguages = res.data;
          }
        },
        error: (err) => {
          if (err.error.code === 404 && !err.error.success) {
            this.toastr.error(this.translate.instant('texto_913'), this.translate.instant('texto_813'));
          } else {
            this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_813'));
          }
        }
      });
  }

  onChangeTexto(event) {
    this.textoF = '';
    let selectedIdTexto = event.value;
    //console.log(selectedIdTexto);
    for (var i = 0; i < this.textos2.length; i++) {
      if (this.textos2[i].id_texto == selectedIdTexto) {
        this.textoF = this.textos2[i].texto;
        //console.log(this.textoF);
        break;
      }
    }
  }

  onChangeCustomTexto(event) {
    this.textoCustomF = '';
    let selectedIdTexto = event.value;
    //console.log(selectedIdTexto);
    for (var i = 0; i < this.textos2.length; i++) {
      if (this.textos2[i].id_texto == selectedIdTexto) {
        this.textoCustomF = this.textos2[i].texto;
        break;
      }
    }
  }
  // Synchronizes the state of saml_enabledF with tieneSSOF.
  syncData(): void {
    this.saml_enabledF = this.tieneSSOF;
  }

  onClickTexto(event) {
    let idioma = this.auth.getLanguage();
    if (idioma == '' || idioma == null) {
      idioma = 'es';
    }
    this.configuracionAvanzadaService
      .searchTextos2(
        this.textos.id_texto,
        false,
        idioma,
        this.auth.getSociedad()
      )
      .subscribe((textos2: Textos2[]) => {
        this.textos2 = textos2;
        this.allTextos = textos2;
        this.filteredTextos = this.allTextos;
      },
        err => {
          this.toastr.error(this.translate.instant('teato_813'), this.translate.instant('texto_813'));
        });
  }

  onClickCustomText(event) {
    let idioma = this.auth.getLanguage();
    if (idioma == '' || idioma == null) {
      idioma = 'es';
    }
    this.configuracionAvanzadaService
      .searchCustomTextos(
        this.textos.id_texto,
        false,
        idioma,
        this.auth.getSociedad()
      )
      .subscribe((textos2: Textos2[]) => {
        this.textos2 = textos2;
        this.allCustomTextos = textos2;
        this.filteredCustomTextos = this.allCustomTextos;
      },
        err => {
          this.toastr.error(this.translate.instant('texto_813'), this.translate.instant('texto_813'));
        });
  }

  ngAfterViewInit() {
    this.matSelect.open();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();

    this.filteredTextos = this.allTextos.filter(txt => {
      const idMatch = txt.id_texto.toLowerCase().includes(filterValue);
      const textoMatch = txt.texto.toLowerCase().includes(filterValue);
      return idMatch || textoMatch;
    });
  }

  applyCustomFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();

    this.filteredCustomTextos = this.allCustomTextos.filter(txt => {
      const idMatch = txt.id_texto.toLowerCase().includes(filterValue);
      const textoMatch = txt.texto.toLowerCase().includes(filterValue);
      return idMatch || textoMatch;
    });
  }

  onChangeClausula(event) {
    this.clausulaF = '';
    let selectedIdClausula = event.value;
    //console.log(selectedIdTexto);
    for (var i = 0; i < this.clausulas2.length; i++) {
      if (this.clausulas2[i].id_clausula == selectedIdClausula) {
        this.clausulaF = this.clausulas2[i].clausula;
        //console.log(this.textoF);
        break;
      }
    }
  }

  onClickClausula(event) {
    this.configuracionAvanzadaService
      .searchClausulas2(
        this.clausulas.id_clausula,
        false,
        this.auth.getSociedad()
      )
      .subscribe((clausulas2: Clausulas2[]) => {
        this.clausulas2 = clausulas2;
      },
        err => {
          this.toastr.error(this.translate.instant('teato_281'), this.translate.instant('texto_813'));
        });
  }

  get dominio() {
    return this.validatingForm.get('dominio');
  }

  get email() {
    return this.validatingForm.get('email');
  }

  get emailSupport() {
    return this.validatingForm.get('emailSupport');
  }

  get aviso() {
    return this.validatingForm.get('aviso');
  }

  get anonimo() {
    return this.validatingForm.get('anonimo');
  }

  get calusulas() {
    return this.validatingForm.get('calusulas');
  }

  get triaje() {
    return this.validatingForm.get('triaje');
  }

  get centros() {
    return this.validatingForm.get('centros');
  }

  get autocomplete() {
    return this.validatingForm.get('autocomplete');
  }

  get conflicto() {
    return this.validatingForm.get('conflicto');
  }

  get conflictoCompliance() {
    return this.validatingForm.get('conflictoCompliance');
  }

  get diasinves() {
    return this.validatingForm.get('diasinves');
  }

  get diasdecisor() {
    return this.validatingForm.get('diasdecisor');
  }

  get diascompliance() {
    return this.validatingForm.get('diascompliance');
  }

  get diasrecepcion() {
    return this.validatingForm.get('diasrecepcion');
  }

  get rutaTerminos() {
    return this.validatingFormDocs.get('rutaTerminos');
  }

  get rutaPolitica() {
    return this.validatingFormDocs.get('rutaPolitica');
  }

  get rutaPoliticaCliente() {
    return this.validatingFormDocs.get('rutaPoliticaCliente');
  }

  get docTerminos() {
    return this.validatingFormDocs.get('docTerminos');
  }

  get docPolitica() {
    return this.validatingFormDocs.get('docPolitica');
  }

  get docPoliticaCliente() {
    return this.validatingFormDocs.get('docPoliticaCliente');
  }

  get docBoton1() {
    return this.validatingFormDocs.get('docBoton1');
  }

  get boton1() {
    return this.validatingFormDocs.get('boton1');
  }

  get docBoton2() {
    return this.validatingFormDocs.get('docBoton2');
  }

  get boton2() {
    return this.validatingFormDocs.get('boton2');
  }

  get docBoton3() {
    return this.validatingFormDocs.get('docBoton3');
  }

  get idiomaDocs() {
    return this.validatingFormDocs.get('idiomaDocs');
  }

  get boton3() {
    return this.validatingFormDocs.get('boton3');
  }

  get rutaDrive() {
    return this.validatingForm.get('rutaDrive');
  }

  get drive() {
    return this.validatingForm.get('drive');
  }

  get popUp() {
    return this.validatingForm.get('popUp');
  }

  get supportForm() {
    return this.validatingForm.get('supportForm')
  }

  /**
   * @description Getter for complianceNotification form control.
   */
  get complianceNotification() {
    return this.validatingForm.get('complianceNotification')
  }


  get documentPreview() {
    return this.validatingForm.get('documentPreview')
  }

  get terminos() {
    return this.validatingFormDocs.get('terminos');
  }
  get politica() {
    return this.validatingFormDocs.get('politica');
  }
  get politicaCliente() {
    return this.validatingFormDocs.get('politicaCliente');
  }
  get logo() {
    return this.validatingFormImages.get('logo');
  }

  get inicio1() {
    return this.validatingFormImages.get('inicio1');
  }

  get inicio2() {
    return this.validatingFormImages.get('inicio2');
  }

  get inicio3() {
    return this.validatingFormImages.get('inicio3');
  }

  get fondo_denunciante() {
    return this.validatingFormImages.get('fondo_denunciante');
  }

  get wizard1() {
    return this.validatingFormImages.get('wizard1');
  }

  get wizard2() {
    return this.validatingFormImages.get('wizard2');
  }

  get wizard3() {
    return this.validatingFormImages.get('wizard3');
  }

  get wizard4() {
    return this.validatingFormImages.get('wizard4');
  }

  get wizard5() {
    return this.validatingFormImages.get('wizard5');
  }

  get wizard6() {
    return this.validatingFormImages.get('wizard6');
  }

  get wizard7() {
    return this.validatingFormImages.get('wizard7');
  }

  get logindenunciante() {
    return this.validatingFormImages.get('logindenunciante');
  }

  get cabeceramail() {
    return this.validatingFormImages.get('cabeceramail');
  }

  get nremitente() {
    return this.validatingFormMail.get('nremitente');
  }

  get remitente() {
    return this.validatingFormMail.get('remitente');
  }

  get srv_mail() {
    return this.validatingFormMail.get('srv_mail');
  }

  get puerto() {
    return this.validatingFormMail.get('puerto');
  }

  get usr_mail() {
    return this.validatingFormMail.get('usr_mail');
  }

  get pass_mail() {
    return this.validatingFormMail.get('pass_mail');
  }

  get auth_mail() {
    return this.validatingFormMail.get('auth_mail');
  }

  get ssl() {
    return this.validatingFormMail.get('ssl');
  }

  get multi() {
    return this.validatingFormMultisociedad.get('multi');
  }

  get tieneSSO() {
    return this.validatingFormMultisociedad.get('tieneSSO');
  }

  get archivardenuncia() {
    return this.validatingFormMultisociedad.get('archivardenuncia');
  }
  get idPersonalizableEnabled() {
    return this.validatingFormMultisociedad.get('idPersonalizableEnabled');
  }

  get gAnalyticsEnabled() {
    return this.validatingFormMultisociedad.get('gAnalyticsEnabled');
  }

  get frmnidioma() {
    return this.validatingFormIdiomas.get('frmnidioma');
  }

  get frmididioma() {
    return this.validatingFormIdiomas.get('frmididioma');
  }

  get frmcomentario() {
    return this.validatingFormIdiomas.get('frmcomentario');
  }

  get chkhabilitado() {
    return this.validatingFormIdiomas.get('chkhabilitado');
  }

  get colorprincipal() {
    return this.validatingFormColores.get('colorprincipal');
  }

  get colorsecundario() {
    return this.validatingFormColores.get('colorsecundario');
  }

  get colorbgseccion1() {
    return this.validatingFormColores.get('colorbgseccion1');
  }

  get colormenulateral() {
    return this.validatingFormColores.get('colormenulateral');
  }

  get colortxtcabeceras() {
    return this.validatingFormColores.get('colortxtcabeceras');
  }

  get colortxtbotones() {
    return this.validatingFormColores.get('colortxtbotones');
  }

  get colorbgseccion2() {
    return this.validatingFormColores.get('colorbgseccion2');
  }

  get colorbgseccion3() {
    return this.validatingFormColores.get('colorbgseccion3');
  }

  get colortxtbtn() {
    return this.validatingFormColores.get('colortxtbtn');
  }

  get colortxtseccion1() {
    return this.validatingFormColores.get('colortxtseccion1');
  }

  get colortxtseccion2() {
    return this.validatingFormColores.get('colortxtseccion2');
  }

  get colortxtseccion3() {
    return this.validatingFormColores.get('colortxtseccion3');
  }

  get colortxttitulo() {
    return this.validatingFormColores.get('colortxttitulo');
  }

  get colortxtFondo() {
    return this.validatingFormColores.get('colortxtFondo');
  }

  get texto_value() {
    return this.validatingFormTextos.get('texto_value');
  }

  get custom_texto_value() {
    return this.validatingFormTextos.get('custom_texto_value');
  }

  get id_texto() {
    return this.validatingFormTextos.get('id_texto');
  }

  get id_custom_texto() {
    return this.validatingFormTextos.get('id_custom_texto');
  }

  get clausula_value() {
    return this.validatingFormClausulas.get('clausula_value');
  }

  get id_clausula() {
    return this.validatingFormClausulas.get('id_clausula');
  }

  get diasverdenuncia() {
    return this.validatingForm.get('diasverdenuncia');
  }

  get saml_enabled() {
    return this.validatingFormSSO.get('saml_enabled');
  }

  get saml_idp_entity_id() {
    return this.validatingFormSSO.get('saml_idp_entity_id');
  }

  get saml_idp_sso_url() {
    return this.validatingFormSSO.get('saml_idp_sso_url');
  }

  get saml_idp_slo() {
    return this.validatingFormSSO.get('saml_idp_slo');
  }

  get saml_idp_cert() {
    return this.validatingFormSSO.get('saml_idp_cert');
  }

  get saml_idp_cert2() {
    return this.validatingFormSSO.get('saml_idp_cert2');
  }

  get saml_mapping_cn() {
    return this.validatingFormSSO.get('saml_mapping_cn');
  }

  get saml_mapping_sn() {
    return this.validatingFormSSO.get('saml_mapping_sn');
  }

  get saml_mapping_email() {
    return this.validatingFormSSO.get('saml_mapping_email');
  }

  get saml_mapping_phone() {
    return this.validatingFormSSO.get('saml_mapping_phone');
  }

  get saml_mapping_national_id() {
    return this.validatingFormSSO.get('saml_mapping_national_id');
  }

  get saml_jit() {
    return this.validatingFormSSO.get('saml_jit');
  }

  get saml_slo() {
    return this.validatingFormSSO.get('saml_slo');
  }

  get saml_force_login() {
    return this.validatingFormSSO.get('saml_force_login');
  }

  get saml_debug() {
    return this.validatingFormSSO.get('saml_debug');
  }

  get saml_sp_entity_id() {
    return this.validatingFormSSO.get('saml_sp_entity_id');
  }

  get saml_sp_pk() {
    return this.validatingFormSSO.get('saml_sp_pk');
  }

  get saml_sp_cert() {
    return this.validatingFormSSO.get('saml_sp_cert');
  }

  get saml_sp_nameid_format() {
    return this.validatingFormSSO.get('saml_sp_nameid_format');
  }

  guardarDatos() {
    let valor1 = '0';
    valor1 = this.selectedTipo;

    let valor2 = '';
    if (this.dominio.value != '') {
      valor2 = this.dominio.value;
    }

    let valor3 = '';
    if (this.email.value != '') {
      valor3 = this.email.value;
    }

    let valor4 = '';
    if (this.aviso.value != '') {
      valor4 = this.aviso.value;
    }

    let valor5 = false;
    let valor51 = '0';
    if (this.selectedClausulas == '1') {
      valor5 = true;
      valor51 = '1';
    }

    let valor6 = '0';
    valor6 = this.selectedConflicto;

    let valor7 = '';
    if (this.diasinves.value != '') {
      valor7 = this.diasinves.value;
    }

    let valor8 = '';
    if (this.diasdecisor.value != '') {
      valor8 = this.diasdecisor.value;
    }

    let valor9 = '';
    if (this.diascompliance.value != '') {
      valor9 = this.diascompliance.value;
    }

    let valor13 = '';
    if (this.diasverdenuncia.value != '') {
      valor13 = this.diasverdenuncia.value;
    }

    let valor17 = false;
    let valor171 = '0';
    if (this.selectedTriaje == '1') {
      valor17 = true;
      valor171 = '1';
    }


    let valor21 = false;
    let valor22 = '0';
    if (this.selectedCenters == '1') {
      valor21 = true;
      valor22 = '1';
    }

    let valor23 = false;
    let valor24 = '0';
    if (this.selectedinputAutocomplete == '1') {
      valor23 = true;
      valor24 = '1';
    }

    let valor25 = '0';
    valor25 = this.selectedPopUp

    let valor26 = '0';
    valor26 = this.selectedRutaDrive;

    let valor27 = '';
    if (this.rutaDrive.value != '') {
      valor27 = this.rutaDrive.value;
    }

    let valor35 = '';
    if (this.diasrecepcion.value != '') {
      valor35 = this.diasrecepcion.value;
    }

    let valor36 = '';
    if (this.emailSupport.value != '') {
      valor36 = this.emailSupport.value;
    }

    let valor37 = '0';
    valor37 = this.selectedSupportForm;

    /**
     * @description Getter for complianceNotification form control.
     */
    let valor40 = '0';
    valor40 = this.selectedComplianceNotification;

    let valor38 = '0';
    valor38 = this.selectedConflictoCompliance;

    let valor39 = '0';
    valor39 = this.selectedDocumentPreview;

    this.configuracionAvanzadaService
      .updateAdvancedParam(
        this.auth.getSociedad(),
        valor1,
        valor2,
        valor3,
        valor4,
        valor51,
        valor6,
        valor7,
        valor8,
        valor9,
        valor13,
        valor171,
        valor22,
        valor24,
        valor25,
        valor26,
        valor27,
        valor35,
        valor36,
        valor37,
        valor38,
        valor39,
        valor40

      )
      .subscribe((res) => {
        if ((res as any).success === true) {
          //Cambiará el valor del Observable y mostrará el menú centros según el valor
          if (valor22 == '1') {
            this.auth.openSidebar(true); //muestra el menú
          } else {
            this.auth.openSidebar(false); //No muestra el menú
          }

          this.toastr.success(
            this.translate.instant('texto_290'),
            this.translate.instant('texto_292')
          );
          this.auth.setAnonimo(valor1);
          this.auth.setRemitente(valor2);
          this.auth.setConsultas(valor3);
          this.auth.setAviso(valor4);
          this.auth.setClausulas(valor5);
          this.auth.setConflicto(valor6);
          this.auth.setDiasInves(valor7);
          this.auth.setDiasDecisor(valor8);
          this.auth.setDiasCompliance(valor9);
          this.auth.setDiasverdenuncia(valor13);
          this.auth.setPopUp(valor25);
          this.auth.setTriaje(valor17);
          this.auth.setCentro(valor21); //asignamos valor al centro
          this.auth.setInputAutocomplete(valor23);
          this.auth.setsupportForm(valor37);
          this.auth.setConflictoCompliance(valor38);
          this.auth.setDocumentPreview(valor39);
          this.auth.setComplianceNotification(valor40);
        } else {
          this.toastr.error(
            this.translate.instant('texto_291'),
            this.translate.instant('texto_292')
          );
        }
        this.router
          .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });
      },
        err => {
          this.toastr.error(this.translate.instant('texto_291'), this.translate.instant('texto_813'));
        });
  }

  /**
  * Uploads and updates multiple configurable documents across different languages.
  *
  * This method handles the complete process of detecting modified files,
  * uploading them, merging their paths into existing language-based JSON structures,
  * and updating the backend configuration.
  *
  * Each document type can have multiple versions depending on the selected language.
  * When a new file is uploaded, it is stored in the backend and its path is added or
  * updated under the corresponding language key.
  *
  * If no new file is selected, the user is notified with an error message.
  *
  * @async
  * @function uploadFiles
  * @throws Displays a translated error message if:
  *
  * @returns {Promise<void>} Resolves once all uploads and updates are successfully completed.
  */
  async uploadFiles() {
    const language: string = this.idiomaDocs.value || this.auth.getLanguage();

    /**
     * Safely parses a JSON string, returning an empty object if parsing fails.
     *
     * This helper ensures that invalid or empty JSON values from the form do not
     * interrupt the upload process.
     *
     * @param {string} val - The JSON string to parse.
     * @returns {object} The parsed object, or an empty object if invalid.
     */
    const parseOrEmpty = (val: string) => {
      try {
        return val ? JSON.parse(val) : {};
      } catch {
        return {};
      }
    };

    /**
     * Uploads a file only if a new file has been selected, keeping the existing JSON otherwise.
     *
     * This helper checks the corresponding form control for file changes.
     * If a new file exists, it triggers the upload process and merges the
     * resulting file path into the existing JSON, under the current language.
     *
     * @async
     * @param {string} controlName - The name of the form control to check for a file.
     * @param {string} docIndex - The document index identifier used in the upload API.
     * @param {object} existingJson - The current JSON structure of the document paths.
     * @returns {Promise<object>} The updated JSON structure including the new file path (if changed).
     */
    const uploadFileIfChanged = async (controlName: string, docIndex: string, existingJson: any) => {
      const fileControl = this.validatingFormDocs.get(controlName)?.value;
      if (!fileControl) return existingJson;

      const newPath = await this.subirDoc(docIndex, language);
      if (!newPath) throw new Error(this.translate.instant('texto_890'));

      return { ...existingJson, [language]: newPath };
    };

    try {
      // Parse existing JSON data from form or ngModel values
      let termsDocPathJson = parseOrEmpty(this.docTerminosF);
      let boton1DocPathJson = parseOrEmpty(this.docBoton1F);
      let boton2DocPathJson = parseOrEmpty(this.docBoton2F);
      let boton3DocPathJson = parseOrEmpty(this.docBoton3F);
      let politicaBecDocPathJson = parseOrEmpty(this.docPoliticaF);
      let politicaClienteDocPathJson = parseOrEmpty(this.docPoliticaClienteF);

      // Upload files only if new ones were selected
      termsDocPathJson = await uploadFileIfChanged('fileSourceTerminos', '1', termsDocPathJson);
      boton1DocPathJson = await uploadFileIfChanged('fileSourceBoton1', '2', boton1DocPathJson);
      boton2DocPathJson = await uploadFileIfChanged('fileSourceBoton2', '3', boton2DocPathJson);
      boton3DocPathJson = await uploadFileIfChanged('fileSourceBoton3', '4', boton3DocPathJson);
      politicaBecDocPathJson = await uploadFileIfChanged('fileSourcePoliticaBec', '5', politicaBecDocPathJson);
      politicaClienteDocPathJson = await uploadFileIfChanged('fileSourcePoliticaCli', '6', politicaClienteDocPathJson);

      // Check if at least one file was modified
      const anyFileChanged =
        this.validatingFormDocs.get('fileSourceTerminos')?.value ||
        this.validatingFormDocs.get('fileSourceBoton1')?.value ||
        this.validatingFormDocs.get('fileSourceBoton2')?.value ||
        this.validatingFormDocs.get('fileSourceBoton3')?.value ||
        this.validatingFormDocs.get('fileSourcePoliticaBec')?.value ||
        this.validatingFormDocs.get('fileSourcePoliticaCli')?.value;

      // Only require files if all related selectors are in "Documento" mode
      const requiredFiles =
        (this.selectedTerminos === '0') &&
        (this.selectedPolitica === '0') &&
        (this.selectedPoliticaCliente === '0');

      if (requiredFiles && !anyFileChanged) {
        throw new Error(this.translate.instant('texto_919'));
      }


      // Build payload with updated and existing JSON values
      const payload: FileParams = {
        id_sociedad: this.auth.getSociedad(),
        id_usuario: this.auth.getIdUser(),
        terminos: this.selectedTerminos ?? '0',
        doc_terminos: JSON.stringify(termsDocPathJson),
        ruta: this.rutaTerminos?.value ?? '',
        politica: this.selectedPolitica ?? '0',
        doc_politica: JSON.stringify(politicaBecDocPathJson),
        rutapolitica: this.rutaPolitica?.value ?? '',
        politicaCliente: this.selectedPoliticaCliente ?? '0',
        doc_politica_cliente: JSON.stringify(politicaClienteDocPathJson),
        rutapoliticacliente: this.rutaPoliticaCliente?.value ?? '',
        boton1: this.selectedBoton1 ?? '0',
        boton2: this.selectedBoton2 ?? '0',
        boton3: this.selectedBoton3 ?? '0',
        docboton1: JSON.stringify(boton1DocPathJson),
        docboton2: JSON.stringify(boton2DocPathJson),
        docboton3: JSON.stringify(boton3DocPathJson)
      };

      // Send updated configuration to the backend
      this.configuracionAvanzadaService.updateFilesParams(payload).subscribe(
        (res) => {
          if ((res as any).success === true) {
            this.toastr.success(
              this.translate.instant('texto_290'),
              this.translate.instant('texto_292')
            );
          } else {
            this.toastr.error(
              this.translate.instant('texto_291'),
              this.translate.instant('texto_292')
            );
          }

          this.router
            .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
            .then(() => this.router.navigate(['/dashboard/layout/advanced-setting']));
        },
        (err) => {
          this.toastr.error(
            this.translate.instant('texto_291'),
            this.translate.instant('texto_813')
          );
        }
      );
    } catch (err) {
      this.toastr.error(this.translate.instant('texto_204'), this.translate.instant('texto_813'));
    }
  }

  guardarColores() {
    let valor1 = '';
    if (this.colorprincipal.value != '') {
      valor1 = this.colorprincipal.value;
    }
    let valor2 = '';
    if (this.colorsecundario.value != '') {
      valor2 = this.colorsecundario.value;
    }
    let valor3 = '';
    if (this.colorbgseccion2.value != '') {
      valor3 = this.colorbgseccion2.value;
    }
    let valor4 = '';
    if (this.colorbgseccion3.value != '') {
      valor4 = this.colorbgseccion3.value;
    }
    let valor5 = '';
    if (this.colortxtbtn.value != '') {
      valor5 = this.colortxtbtn.value;
    }
    let valor6 = '';
    if (this.colortxtseccion1.value != '') {
      valor6 = this.colortxtseccion1.value;
    }
    let valor7 = '';
    if (this.colortxtseccion2.value != '') {
      valor7 = this.colortxtseccion2.value;
    }
    let valor8 = '';
    if (this.colortxtseccion3.value != '') {
      valor8 = this.colortxtseccion3.value;
    }
    let valor9 = '';
    if (this.colortxttitulo.value != '') {
      valor9 = this.colortxttitulo.value;
    }
    let valor10 = '';
    if (this.colorbgseccion1.value != '') {
      valor10 = this.colorbgseccion1.value;
    }
    let valor11 = '';
    if (this.colormenulateral.value != '') {
      valor11 = this.colormenulateral.value;
    }
    let valor12 = '';
    if (this.colortxtcabeceras.value != '') {
      valor12 = this.colortxtcabeceras.value;
    }
    let valor13 = '';
    if (this.colortxtbotones.value != '') {
      valor13 = this.colortxtbotones.value;
    }
    let valor14 = '';
    if (this.colortxtFondo.value != '') {
      valor14 = this.colortxtFondo.value;
    }
    this.configuracionAvanzadaService
      .updateAdvancedParam3(
        this.auth.getSociedad(),
        valor1,
        valor2,
        valor3,
        valor4,
        valor5,
        valor6,
        valor7,
        valor8,
        valor9,
        valor10,
        valor11,
        valor12,
        valor13,
        valor14
      )
      .subscribe((res) => {
        if (res == 200) {
          this.toastr.success(
            this.translate.instant('texto_290'),
            this.translate.instant('texto_292')
          );
          this.auth.setColorprincipal(valor1);
          this.auth.setColorsecundario(valor2);
          this.auth.setColorbgseccion2(valor3);
          this.auth.setColorbgseccion3(valor4);
          this.auth.setColortxtbtn(valor5);
          this.auth.setColortxtseccion1(valor6);
          this.auth.setColortxtseccion2(valor7);
          this.auth.setColortxtseccion3(valor8);
          this.auth.setColortxttitulo(valor9);
          this.auth.setColorbgseccion1(valor10);
          this.auth.setColormenulateral(valor11);
          this.auth.setColortxtcabeceras(valor12);
          this.auth.setColortxtbotones(valor13);
          window.location.reload();
        } else {
          this.toastr.error(
            this.translate.instant('texto_291'),
            this.translate.instant('texto_292')
          );
          this.router
            .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/dashboard/layout/advanced-setting']);
            });
        }
      },
        err => {
          this.toastr.error(this.translate.instant('texto_291'), this.translate.instant('texto_813'));
        });
  }

  guardarDatosCorreo() {
    let valor1 = '';
    if (this.nremitente.value != '') {
      valor1 = this.nremitente.value;
    }
    let valor2 = '';
    if (this.remitente.value != '') {
      valor2 = this.remitente.value;
    }
    let valor3 = '';
    if (this.srv_mail.value != '') {
      valor3 = this.srv_mail.value;
    }
    let valor4 = '';
    if (this.puerto.value != '') {
      valor4 = this.puerto.value;
    }
    let valor5 = '';
    if (this.usr_mail.value != '') {
      valor5 = this.usr_mail.value;
    }
    let valor6 = '';
    if (this.pass_mail.value != '') {
      valor6 = this.pass_mail.value;
    }
    let valor7 = '0';
    if (this.ssl.value == true) {
      valor7 = '1';
    }
    let valor8 = '0';
    if (this.auth_mail.value == true) {
      valor8 = '1';
    }
    this.configuracionAvanzadaService
      .updateAdvancedParam2(
        this.auth.getSociedad(),
        valor1,
        valor2,
        valor3,
        valor4,
        valor5,
        valor6,
        valor7,
        valor8
      )
      .subscribe((res) => {
        if ((res as any).success === true) {
          this.toastr.success(
            this.translate.instant('texto_290'),
            this.translate.instant('texto_292')
          );
          this.auth.setNremitente(valor1);
          this.auth.setRemitente(valor2);
          this.auth.setSrv_mail(valor3);
          this.auth.setPuerto(valor4);
          this.auth.setUsr_mail(valor5);
          this.auth.setPass_mail(valor6);
          this.auth.setSsl(valor7);
          this.auth.setAuth_mail(valor8);
        } else {
          this.toastr.error(
            this.translate.instant('texto_291'),
            this.translate.instant('texto_292')
          );
        }
        this.router
          .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });
      },
        err => {
          if (err.status === 409) {
            this.toastr.error(this.translate.instant('texto_291'), this.translate.instant('texto_813'));
          } else {
            this.toastr.error(this.translate.instant('texto_291'), this.translate.instant('texto_813'));
          }
        });
  }

  guardarMultisociedad() {
    let valor1 = this.multi.value ? '1' : '0';
    let valor2 = this.tieneSSO.value ? '1' : '0';
    let valor3 = this.archivardenuncia.value ? '1' : '0';
    let valor4 = this.idPersonalizableEnabled.value ? '1' : '0';
    let valor5 = this.gAnalyticsEnabled.value ? '1' : '0';

    this.configuracionAvanzadaService.updateAdvancedParam4(this.auth.getSociedad(), valor1, valor2, valor3, valor4, valor5)
      .subscribe((res) => {
        if ((res as any).success === true) {
          localStorage.setItem('archdenuncia', valor3);
          localStorage.setItem('idPersonalizable', valor4);
          localStorage.setItem("HabSSO", valor2);
          this.auth.setTieneSSO(valor2);
          this.toastr.success(this.translate.instant('texto_290'),
            this.translate.instant('texto_292')
          );
          // Llamar al nuevo método para actualizar saml_enabled
          this.configuracionAvanzadaService.updateSamlEnabled(this.auth.getSociedad(), valor2)
            .subscribe((res) => {
              if (res == 200) {
                // Actualizar el valor de saml_enabled en la autenticación
                this.auth.setsaml_enabled(valor2);
              }
              this.router.navigateByUrl('/RefreshComponent', {
                skipLocationChange: true,
              })
                .then(() => {
                  this.router.navigate(['/dashboard/layout/advanced-setting']);
                });
            });
        }
      },
        err => {
          if (err.status === 409) {
            this.toastr.error(this.translate.instant('texto_291'), this.translate.instant('texto_813'));
          } else {
            this.toastr.error(this.translate.instant('texto_291'), this.translate.instant('texto_813'));
          }
        });
  }

  guardarTextos() {
    let idioma = this.auth.getLanguage();
    if (idioma == '' || idioma == null) {
      idioma = 'es';
    }

    let valor1 = this.id_texto.value;
    let valor2 = this.texto_value.value.replace(/href="([^"]*)"/g, "href='$1'");

    this.configuracionAvanzadaService
      .updateTextos(valor1, valor2, idioma, this.auth.getSociedad())
      .subscribe((res) => {
        if (res == 200) {
          this.configuracionAvanzadaService
            .generarFicheroTextos(idioma, this.auth.getSociedad())
            .subscribe((res) => {
              if (res == 200) {
                this.toastr.success(
                  this.translate.instant('texto_525'),
                  this.translate.instant('texto_527')
                );
                this.auth.setId_texto(valor1);
                this.auth.setTexto(valor2);
                this.router
                  .navigateByUrl('/RefreshComponent', {
                    skipLocationChange: true,
                  })
                  .then(() => {
                    this.router.navigate([
                      '/dashboard/layout/advanced-setting',
                    ]);
                  });
              } else {
                this.toastr.error(
                  this.translate.instant('texto_526'),
                  this.translate.instant('texto_527')
                );
              }
            });
        } else {
          this.toastr.error(
            this.translate.instant('texto_526'),
            this.translate.instant('texto_527')
          );
        }
        this.router
          .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });
      }, err => {
        this.toastr.error(
          this.translate.instant('texto_526'),
          this.translate.instant('texto_527')
        );
      });
  }

  guardarTextosPersonalizables() {
    let idioma = this.auth.getLanguage();
    if (idioma == '' || idioma == null) {
      idioma = 'es';
    }
    let valor1 = '';
    let valor2 = '';
    if (this.custom_texto_value.value != '') {
      valor1 = this.id_custom_texto.value;
      valor2 = this.custom_texto_value.value.replace(/href="([^"]*)"/g, "href='$1'");
    }
    this.configuracionAvanzadaService
      .updateTextos(valor1, valor2, idioma, this.auth.getSociedad())
      .subscribe((res) => {
        if (res == 200) {
          this.configuracionAvanzadaService
            .generarFicheroTextos(idioma, this.auth.getSociedad())
            .subscribe((res) => {
              if (res == 200) {
                this.toastr.success(
                  this.translate.instant('texto_525'),
                  this.translate.instant('texto_527')
                );
                this.auth.setId_texto(valor1);
                this.auth.setTexto(valor2);
                this.router
                  .navigateByUrl('/RefreshComponent', {
                    skipLocationChange: true,
                  })
                  .then(() => {
                    this.router.navigate([
                      '/dashboard/layout/advanced-setting',
                    ]);
                  });
              } else {
                this.toastr.error(
                  this.translate.instant('texto_526'),
                  this.translate.instant('texto_527')
                );
              }
            });
        } else {
          this.toastr.error(
            this.translate.instant('texto_526'),
            this.translate.instant('texto_527')
          );
        }
        this.router
          .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });
      }, err => {
        this.toastr.error(
          this.translate.instant('texto_526'),
          this.translate.instant('texto_527')
        );
      });
  }

  guardarClausulas() {
    let idioma = this.auth.getLanguage();
    if (idioma == '' || idioma == null) {
      idioma = 'es';
    }
    let valor1 = '';
    let valor2 = '';
    //console.log(this.texto_value.value);
    //console.log(this.id_texto.value);
    if (this.clausula_value.value != '') {
      valor1 = this.id_clausula.value;
      valor2 = this.clausula_value.value;
    }
    this.configuracionAvanzadaService
      .updateClausulas(valor1, valor2, this.auth.getSociedad())
      .subscribe(res => {
        if ((res as any)?.success === true) {
          this.toastr.success(
            this.translate.instant('texto_528'),
            this.translate.instant('texto_530')
          );
          this.auth.setId_clausula(valor1);
          this.auth.setClausula(valor2);
        } else {
          this.toastr.error(
            this.translate.instant('texto_529'),
            this.translate.instant('texto_530')
          );
        }
        this.router
          .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });
      },
        err => {
          this.toastr.error(this.translate.instant('teato_281'), this.translate.instant('texto_813'));

        });
  }
  guardarSSO() {
    let valor1 = this.saml_enabled.value ? '1' : '0';
    let valor2 = this.saml_idp_entity_id.value || '';
    let valor3 = this.saml_idp_sso_url.value || '';
    let valor4 = this.saml_idp_slo.value || '';
    let valor5 = this.saml_idp_cert.value || '';
    let valor6 = this.saml_idp_cert2.value || '';
    let valor7 = this.saml_mapping_cn.value || '';
    let valor8 = this.saml_mapping_sn.value || '';
    let valor9 = this.saml_mapping_email.value || '';
    let valor10 = this.saml_mapping_phone.value || '';
    let valor11 = this.saml_mapping_national_id.value || '';
    let valor12 = this.saml_jit.value ? '1' : '0';
    let valor13 = this.saml_slo.value ? '1' : '0';
    let valor14 = this.saml_force_login.value ? '1' : '0';
    let valor15 = this.saml_debug.value ? '1' : '0';
    let valor16 = this.saml_sp_entity_id.value || '';
    let valor17 = this.saml_sp_pk.value || '';
    let valor18 = this.saml_sp_cert.value || '';
    let valor19 = this.selectedsaml_sp_nameid_format || '0';

    this.configuracionAvanzadaService
      .updateSSOParam(
        this.auth.getSociedad(),
        valor1,
        valor2,
        valor3,
        valor4,
        valor5,
        valor6,
        valor7,
        valor8,
        valor9,
        valor10,
        valor11,
        valor12,
        valor13,
        valor14,
        valor15,
        valor16,
        valor17,
        valor18,
        valor19
      )
      .subscribe((res) => {
        if ((res as any)?.success === true) {
          this.toastr.success(
            this.translate.instant('texto_290'),
            this.translate.instant('texto_292')
          );
          // Actualizar el valor de saml_enabled en la autenticación
          this.auth.setsaml_enabled(valor1);
        } else {
          this.toastr.error(
            this.translate.instant('texto_291'),
            this.translate.instant('texto_292')
          );
        }
        this.router
          .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });
      },
        err => {
          this.toastr.error(this.translate.instant('texto_291'), this.translate.instant('texto_813'));
        });
  }

  get f() {
    return this.validatingFormImages.controls;
  }

  onFileChange(event, fichero) {
    if (event.target.files.length > 0) {
      //console.log(" ---- fichero:" + fichero);
      const file = event.target.files[0];
      if (file.size > 20 * 1024 * 1024) {
        this.validateSize();
        return;
      }
      this.validatingFormImages.patchValue({
        fileSource: file,
        fich: fichero,
      });
      this.subirImagenes();
    }
  }

  onFileChangeII(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.size > 20 * 1024 * 1024) {
        this.validateSize();
        return;
      }
      this.validatingFormIdiomas.patchValue({
        fileSourceIdioma: file,
      });
      //this.subirIconoIdioma();
    }
  }

  onFileChangeTerminos(event: any, fichero: string, key: string) {
    this.handleFileChange(event, fichero, key, 'fileSourceTerminos', 'fichTerminos');
  }

  onFileChangeBoton1(event: any, fichero: string, key: string) {
    this.handleFileChange(event, fichero, key, 'fileSourceBoton1', 'fichBoton1');
  }

  onFileChangeBoton2(event: any, fichero: string, key: string) {
    this.handleFileChange(event, fichero, key, 'fileSourceBoton2', 'fichBoton2');
  }

  onFileChangeBoton3(event: any, fichero: string, key: string) {
    this.handleFileChange(event, fichero, key, 'fileSourceBoton3', 'fichBoton3');
  }

  onFileChangePoliticaBec(event: any, fichero: string, key: string) {
    this.handleFileChange(event, fichero, key, 'fileSourcePoliticaBec', 'fichPoliticaBec');
  }

  onFileChangePoliticaCli(event: any, fichero: string, key: string) {
    this.handleFileChange(event, fichero, key, 'fileSourcePoliticaCli', 'fichPoliticaCli');
  }

  /**
   * Generic file handler for file inputs.
   * Validates size and type (only PDF), updates form controls and preview flags.
   */
  private handleFileChange(
    event: any,
    fichero: string,
    key: string,
    fileSourceControl: string,
    fileNameControl: string
  ): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    // Validate size (max. 20 MB)
    if (file.size > 20 * 1024 * 1024) {
      this.validateSize();
      input.value = '';
      return;
    }

    // Validate type (only PDF)
    if (!file.type.includes('pdf')) {
      this.toastr.error(this.translate.instant('texto_928'));
      this.validatingFormDocs.patchValue({
        [fileSourceControl]: null,
        [fileNameControl]: null,
      });
      this.pdfPreviews[key] = false;
      input.value = '';
      return;
    }

    //is valid
    this.validatingFormDocs.patchValue({
      [fileSourceControl]: file,
      [fileNameControl]: fichero,
    });
    this.pdfPreviews[key] = true;
  }


  validateSize() {
    this.toastr.error(this.translate.instant('texto_333')); 3
  }

  viewPdfFromFormControl(controlName: string) {
    const file = this.validatingFormDocs.get(controlName)?.value;
    if (file) {
      const blobUrl = URL.createObjectURL(file);
      this.url = blobUrl;
      this.showFile = true;
    }
  }

  viewPdfFromUrl(url: string): void {
    if (!url) return;

    this.url = url;
    this.showFile = true;
    const extension = url.split('.').pop()?.toLowerCase() || '';
    this.mimeType = this.fileUtilsService.getMimeType(extension);
  }

  subirImagenes() {
    const formData = new FormData();
    formData.append('file', this.validatingFormImages.get('fileSource').value);
    formData.append('id_user', this.auth.getIdUser());
    formData.append('fichero', this.validatingFormImages.get('fich').value);
    formData.append('id_sociedad', this.auth.getSociedad());
    //console.log(this.auth.getSociedad() + " ---- fich:" + this.validatingFormImages.get('fich').value);
    this.http
      .post(`${this.PHP_API_SERVER}/api/upload_images.php`, formData)
      .subscribe(
        (res) => {
          if (res == 200) {
            this.toastr.success(
              this.translate.instant('texto_202'),
              this.translate.instant('texto_203')
            );
            /*this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });*/
            window.location.reload();
            //console.log("res:" + res);
          } else {
            this.toastr.error(
              this.translate.instant('texto_204'),
              this.translate.instant('texto_203')
            );
            this.router
              .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['/dashboard/layout/advanced-setting']);
              });
            //console.log("res:" + res);
          }
        },
        (err) => {
          if (err.status == 400) {
            this.toastr.error(this.translate.instant('texto_181'), this.translate.instant('texto_203'));
          } else {
            this.toastr.error(this.translate.instant('texto_204'), this.translate.instant('texto_203'));
          }
          this.router
            .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/dashboard/layout/advanced-setting']);
            });
        }
      );
  }

  subirIconoIdioma(id_idioma: string) {

    const formData = new FormData();
    formData.append(
      'file',
      this.validatingFormIdiomas.get('fileSourceIdioma').value
    );
    //formData.append('id_user', this.auth.getIdUser());
    formData.append('id_idioma', id_idioma);
    this.http
      .post(`${this.PHP_API_SERVER}/api/upload_iconoidioma.php`, formData)
      .subscribe(
        (res) => {
          if (res == 200) {
            this.toastr.success(
              this.translate.instant('texto_660'),
              this.translate.instant('texto_661')
            );
          } else {
            this.toastr.error(
              this.translate.instant('texto_662'),
              this.translate.instant('texto_661')
            );
          }
          this.router
            .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/dashboard/layout/advanced-setting']);
            });
        },
        (err) => {
          this.toastr.error(
            this.translate.instant('texto_662'),
            this.translate.instant('texto_661')
          );
          this.router
            .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/dashboard/layout/advanced-setting']);
            });
        }
      );
  }

  subirDoc2(doc: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      if (doc === '1') {
        formData.append('fichero', this.validatingFormDocs.get('fichTerminos')?.value);
        formData.append('file', this.validatingFormDocs.get('fileSourceTerminos')?.value);
      } else if (doc === '2') {
        formData.append('fichero', this.validatingFormDocs.get('fichBoton1')?.value);
        formData.append('file', this.validatingFormDocs.get('fileSourceBoton1')?.value);
      } else if (doc === '3') {
        formData.append('fichero', this.validatingFormDocs.get('fichBoton2')?.value);
        formData.append('file', this.validatingFormDocs.get('fileSourceBoton2')?.value);
      } else if (doc === '4') {
        formData.append('fichero', this.validatingFormDocs.get('fichBoton3')?.value);
        formData.append('file', this.validatingFormDocs.get('fileSourceBoton3')?.value);
      } else if (doc === '5') {
        formData.append('fichero', this.validatingFormDocs.get('fichPoliticaBec')?.value);
        formData.append('file', this.validatingFormDocs.get('fileSourcePoliticaBec')?.value);
      } else if (doc === '6') {
        formData.append('fichero', this.validatingFormDocs.get('fichPoliticaCli')?.value);
        formData.append('file', this.validatingFormDocs.get('fileSourcePoliticaCli')?.value);
      }

      formData.append('id_user', this.auth.getIdUser());
      formData.append('nomboton1', this.translate.instant('texto_467'));
      formData.append('nomboton2', this.translate.instant('texto_487'));
      formData.append('nomboton3', this.translate.instant('texto_489'));
      formData.append('nempresa', this.translate.instant('texto_6'));
      formData.append('id_sociedad', this.auth.getSociedad());

      this.http.post(`${this.PHP_API_SERVER}/api/upload_images.php`, formData)
        .subscribe({
          next: (res: any) => {
            if (res == 200) {
              this.toastr.success(this.translate.instant('texto_202'), this.translate.instant('texto_203'));
              resolve();
            } else {
              this.toastr.error(this.translate.instant('texto_204'), this.translate.instant('texto_203'));
              reject('Error al subir doc');
            }
          },
          error: (err) => {
            if (err.status == 400) {
              this.toastr.error(this.translate.instant('texto_181'), this.translate.instant('texto_203'));
            } else {
              this.toastr.error(this.translate.instant('texto_204'), this.translate.instant('texto_203'));
            }
            reject(err);
          }
        });
    });
  }


  subirDoc(docKey: string, language: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      // Map controles formulario
      const docMap: { [key: string]: string } = {
        '1': 'Terminos',
        '2': 'Boton1',
        '3': 'Boton2',
        '4': 'Boton3',
        '5': 'PoliticaBec',
        '6': 'PoliticaCli'
      };

      // Map nombres de arch
      const fileNameMap: { [key: string]: string } = {
        '1': 'terminos-y-condiciones-uso-canal',
        '2': `${this.translate.instant('texto_6')}-${this.translate.instant('texto_467')}`,
        '3': `${this.translate.instant('texto_6')}-${this.translate.instant('texto_487')}`,
        '4': `${this.translate.instant('texto_6')}-${this.translate.instant('texto_489')}`,
        '5': 'politica-de-privacidad-becompliance',
        '6': 'politica-de-privacidad-canal'
      };

      const fileControlName = `fileSource${docMap[docKey]}`;
      const fichControlName = `fich${docMap[docKey]}`;

      const fileValue = this.validatingFormDocs.get(fileControlName)?.value;
      const fichValue = this.validatingFormDocs.get(fichControlName)?.value;

      if (!fileValue || !fichValue) {
        this.toastr.error(this.translate.instant('texto_181'), this.translate.instant('texto_203'));
        return reject('No file or document name selected');
      }

      const nombreDoc = `${fileNameMap[docKey]}-${language}.pdf`;

      formData.append('file', fileValue);
      formData.append('fichero', fichValue);
      formData.append('id_sociedad', this.auth.getSociedad());
      formData.append('nombre_doc', nombreDoc);

      this.configuracionAvanzadaService.uploadAdvancedSettingsFiles(formData)
        .subscribe({
          next: (res) => {
            if (res?.success) {
              this.toastr.success(this.translate.instant('texto_202'), this.translate.instant('texto_203'));
              resolve(res.data.file_url);
            } else {
              this.toastr.error(this.translate.instant('texto_204'), this.translate.instant('texto_203'));
              reject(res?.errors || 'Error al subir doc');
            }
          },
          error: (err) => {
            if (err.status === 400) {
              this.toastr.error(this.translate.instant('texto_181'), this.translate.instant('texto_203'));
            } else {
              this.toastr.error(this.translate.instant('texto_204'), this.translate.instant('texto_203'));
            }
            reject(err);
          }
        });
    });
  }



  hideModal() {
    this.IsHiddenForm = false;
  }

  editIdioma(idioma: Idiomas) {
    this.IsHiddenForm = true;

    this.id_idioma = idioma.id_idioma;
    this.n_idioma = idioma.n_idioma;
    this.bandera = idioma.bandera;
    this.comentario = idioma.comentario;
    this.Habilitado = idioma.habilitado;

    this.Habilitadochk = false;
    if (this.Habilitado == '1') {
      this.Habilitadochk = true;
    }

    //console.log("Habilitado: ", this.Habilitado);
    //console.log("Habilitadochk: ", this.Habilitadochk);
  }

  updateIdioma(
    id_idioma: string,
    n_idioma: string,
    comentario: string,
    Habilitado: string
  ) {
    let valor2 = n_idioma;
    if (this.frmnidioma.value != '' && this.frmnidioma.value != n_idioma) {
      valor2 = this.frmnidioma.value;
    }

    let valor3 = Habilitado;
    let valor32 = '0';
    if (this.chkhabilitado.value == true) {
      valor32 = '1';
    }
    if (valor32 != valor3) {
      valor3 = valor32;
    }

    let valor4 = comentario;
    if (
      this.frmcomentario.value != '' &&
      this.frmcomentario.value != comentario
    ) {
      valor4 = this.frmcomentario.value;
    }

    this.configuracionAvanzadaService
      .updateIdioma(id_idioma, valor2, valor4, valor3)
      .subscribe((res) => {
        if (res == 200) {

          if (this.validatingFormIdiomas.get('fileSourceIdioma').value != '') {
            this.subirIconoIdioma(id_idioma);
          }
          // this.toastr.success(
          //   this.translate.instant('texto_663'),
          //   this.translate.instant('texto_661')
          // );
        } else {
          this.toastr.error(
            this.translate.instant('texto_664'),
            this.translate.instant('texto_661')
          );
        }
        this.router
          .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/dashboard/layout/advanced-setting']);
          });
      }, err => {
        this.toastr.error(
          this.translate.instant('texto_664'),
          this.translate.instant('texto_661')
        );
      });
  }


  /**
   * Custom validation function form emails separated by ";"
   * @param control field value
   * @returns
   */
  validateEmails(control: AbstractControl): { [key: string]: any } | null {
    const emailList = control.value ? control.value.split(';').map(email => email.trim()) : [];
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    // Search for invalid emails
    const invalidEmails = emailList.filter(email => !emailPattern.test(email));

    // If there are email invalids, return an object with the error
    if (invalidEmails.length > 0) {
      return { 'invalidEmails': invalidEmails.join(', ') };
    }

    // If there are no errors, return null
    return null;
  }
}
